import {useLocation, useNavigate} from 'react-router-dom';
import {useRecoilState} from 'recoil';
import {informationAtom} from '../store/InformationStore';

export const useSafeNavigate = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [information, setInformation] = useRecoilState(informationAtom);

    return (to, options) => {
        if (location.pathname === "/simulation") {
            if (information.simulationNumber === 9 && information.simulationStep === 4) {
                setInformation(prev => ({
                    ...prev,
                    clickAddress: "/remaining-usage"
                }));
            } else
                setInformation(prev => ({
                    ...prev,
                    clickAddress: to === -1 ? '/' : to
                }));
            return;
        }
        return navigate(to, options);
    };
};